<template>
    <div>
        <div class="title">Вы почти у цели. Осталось подтвердить компетенции и навыки</div>
        <router-link
            class="btn"
            to="/account/competences/#todo-replace-link"
        >Подтвердить</router-link>
    </div>
</template>

<script>
export default {
    name: 'UserPopupComplete',
};
</script>

<style scoped>
    .title {
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 26px;
        text-align: center;
        color: #2A2626;
        margin: 16px 0;
    }

    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        background: #F7F7F8;
        border-radius: 4px;
        /*font-family: Proxima Nova;*/
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        height: 48px;
        color: #4663AB;
    }
</style>